import { render, staticRenderFns } from "./PremiumTable.vue?vue&type=template&id=600a32c1&scoped=true&"
import script from "./PremiumTable.vue?vue&type=script&lang=js&"
export * from "./PremiumTable.vue?vue&type=script&lang=js&"
import style0 from "./PremiumTable.vue?vue&type=style&index=0&id=600a32c1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600a32c1",
  null
  
)

export default component.exports